import {
  request
} from '@/network/request.js'
export function public_uploadimg(data) { //图片上传
  return request({
    url: '/File/uploadImg',
    data,
    method: 'post'

  })
};
export function login_loginin(data) { //登录
  return request({
    url: '/login/userLogin',
    data,
    method: 'post'

  })
};
export function login_loginup(data) { //注册
  return request({
    url: '/login/userReg',
    data,
    method: 'post'
  })
};
export function login_editpwd(data) { //修改密码
  return request({
    url: '/login/editUserPassword',
    data,
    method: 'post'

  })
};
export function login_getcode(data) { //获取邮箱验证码发送接口
  return request({
    url: '/login/sendEmailCode',
    data,
    method: 'post'
  })
};
export function login_editpasswordcode(data) { //获取邮箱验证码发送接口
  return request({
    url: '/login/editPasswordSendEmailCode',
    data,
    method: 'post'
  })
};
export function login_edituser(data) { //修改个人信息
  return request({
    url: '/user/editUser',
    data,
    method: 'get'

  })
};
export function login_getuser(data) { //获取个人信息
  return request({
    url: '/user/userInfo',
    data,
    method: 'get'

  })
};
export function login_getcollectcard(data) { //获取收藏卡信息
  return request({
    url: '/user/getUserCards',
    data,
    method: 'get'

  })
};
export function product_main_list(data) { //主线产品列表
  return request({
    url: '/data/productList',
    data,
    method: 'get'

  })
};
export function product_minor_list(data) { //周边产品列表
  return request({
    url: '/data/perProductList',
    data,
    method: 'get'

  })
};
export function swiper_list(data) { //banner列表
  return request({
    url: '/data/bannerList',
    data,
    method: 'get'

  })
};
// 验证相关
export function verify_api(data) { //验证核验码api
  return request({
    url: '/user/verifyCode',
    data,
    method: 'post'

  })
};
// 验证相关
export function verify_api_nologin(data) { //验证核验码(不登录)api
  return request({
    url: '/Data/verifyCode',
    data,
    method: 'post'

  })
};
//获取ip所在地接口
export function get_ip_address(data) { //获取ip所在地接口
  return request({
    url: '/login/getRegion',
    data,
    method: 'get'
  })
};
//获取通用内容管理接口
export function get_common_content(data) { //获取通用内容管理接口
  return request({
    url: '/data/ContentList',
    data,
    method: 'get'
  })
};



// WEBPACK FOOTER //
// ./src/network/index.js